/**
 * Checklist Question Component
 *
 * This code defines a React component called ChecklistQuestion that represents an individual question in a checklist. 
 * It handles the checking of the question and adds or removes points based on the checked value. 
 * The component receives the question and its checked status as props, 
 * and updates the points and checked status when the user clicks on the checkbox.
 * The component also checks if the user is a team captain and if the hunt status is not ended,
 * and displays the checkbox accordingly. Finally, the component renders the 
 * question description and the points associated with the question.
 */

import React from 'react'
import PropTypes from 'prop-types'
import { isTeamCaptain, getHuntStatus } from '../../utils/team-data'
import SvgCheck from '../svg/check'

class ChecklistQuestion extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      hunt_status: `pending`,
    }
    this.handleUpdate = this.handleUpdate.bind(this)
  }

  componentDidMount() {
    this.setState({
      hunt_status: getHuntStatus(),
    })
  }

  componentDidUpdate() {}

  handleUpdate() {
    const { question, updatePoints, checked } = this.props
    let new_checked = !checked
    console.log(`Prev: ${checked} New: ${new_checked}`)
    const points = question.answer_value ? question.answer_value : 5
    if (new_checked) {
      updatePoints(points, { id: question.id, checked: new_checked, points: points })
    } else {
      updatePoints(-points, { id: question.id, checked: new_checked, points: points })
    }
  }

  render() {
    const { question, checked } = this.props
    const { hunt_status } = this.state
    const isCaptain = isTeamCaptain()
    const showInput = isCaptain && hunt_status != `ended`
    const checkedClass = checked ? `checked` : ``

    return (
      <div className="checklist-item-wrapper">
        <div className="checklist-item card mb-3">
          <div className="card-header">
            <div className="row">
              {showInput ? (
                <div className="col">
                  <button className={`checkbox ${checkedClass}`} onClick={this.handleUpdate} title="Check">
                    <span className={`svg-container d-flex align-items-center justify-content-center w-100 h-100`}>
                      <SvgCheck />
                    </span>
                  </button>
                </div>
              ) : (
                <div className="col">
                  <div className={`checkbox disabled ${checkedClass}`}>
                    <span className={`svg-container d-flex align-items-center justify-content-center w-100 h-100`}>
                      <SvgCheck />
                    </span>
                  </div>
                </div>
              )}
              <div className="col text-right points">{question.answer_value} pts</div>
            </div>
          </div>
          <div className="card-body" dangerouslySetInnerHTML={{ __html: question.description }} />
        </div>
      </div>
    )
  }
}

export default ChecklistQuestion

ChecklistQuestion.propTypes = {
  question: PropTypes.object,
  checked: PropTypes.bool,
  updatePoints: PropTypes.func,
}
